export default __webpack_public_path__ + "static/media/480_business03-it-mobile.6335e5a1.png";